import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AppIcon } from '@tablesready/frontend-icons';

import { FrontendModalService } from '@tablesready/frontend-modal';

@Component({
  selector: 'tablesready-delete-table-modal',
  templateUrl: './delete-table-modal.component.html',
  styleUrls: ['./delete-table-modal.component.scss'],
})
export class DeleteTableModalComponent {
  @Input() resourceName?: string;

  icon = AppIcon;

  deleteResources = new FormControl(true, Validators.required);

  constructor(private readonly modalController: FrontendModalService) { }

  close(): void {
    this.modalController.dismiss();
  }

  delete(): void {
    this.modalController.dismiss(Boolean(this.deleteResources?.value));
  }

  cancel(): void {
    this.modalController.dismiss(0);
  }

  protected readonly AppIcon = AppIcon;
}
